import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import QueryTimeslotKindLimitation from 'graphql/queries/QueryTimeslotKindLimitation'

const FetchTimeslotKindLimitations = {
	
	fetch: ( { guid = null, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'timeslot_kind_limitation', QueryTimeslotKindLimitation, {
			variables: {
				timeslot_kind_guid: guid
			},
			resultPath: [ 'timeslot_kind', 'limitation' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	},
}

export default FetchTimeslotKindLimitations
